import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private users: UserService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    const token = this.users.getToken();

    // No token - redirect to login
    if (!token) {
      return this.router.createUrlTree(['/account/login'], {
        queryParams: { returnUrl: state.url }
      });
    }

    // Token expired - clear session synchronously then redirect.
    // We use clearSessionLocally() here (not logout()) because logout() returns an
    // Observable that must be subscribed to — a guard's canActivate must return
    // synchronously, so we cannot wait for the HTTP call.
    if (this.users.isTokenExpired()) {
      this.users.clearSessionLocally();
      return this.router.createUrlTree(['/account/login'], {
        queryParams: { returnUrl: state.url, reason: 'session_expired' }
      });
    }

    return true;
  }
}
